import {
  Alert,
  Button,
  Card,
  CardActionArea,
  CardHeader,
  FormControl,
  Icon,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  Zoom,
} from "@mui/material";
import { useState } from "react";
import { ReactComponent as DeleteSVG } from "../../assets/delete.svg";
import { docs_enum } from "../../utils/helpers";
import { ReactComponent as AttachmentAvatar } from "../../assets/attacchment.svg";
import { Input } from "antd";
import { postFeedBack } from "../../actions/user";
import { connect, useStore } from "react-redux";
const { TextArea } = Input;

export default connect(({ userProfile }) => ({ userProfile }), {
  postFeedBack,
})((props) => {
  const i18n = useStore().getState().i18n;
  const [type, setType] = useState("");
  const [description, setDescription] = useState("");

  const [target, setTarget] = useState();

  const [file, setFile] = useState();

  const [alertOpen, setAlertOpen] = useState(false);


  //   const handleFileChange = (e) => {
  //     let file = e.target.files[0];
  //     // if (file.name.includes(".")) {
  //     //     setAlertText("Invalid File Extension !");
  //     // }
  //     setTarget(e);
  //     setFile(file);
  //     // if (props.customFileChange) {
  //     //   props.customFileChange(e);
  //     // }
  //   };

  //   const deleteFile = () => {
  //     setTarget();
  //     setFile();
  //   };

  //   const renderFileDetails = () => {
  //     return (
  //       <div className="fileDetails">
  //         <div className="detail">
  //           <div className="name"> {formatfileName(file?.name, 30)}</div>
  //           <div className="size"> {file.size / 1000} KB</div>
  //         </div>
  //         <div className="icon">
  //           <DeleteSVG onClick={deleteFile} />
  //         </div>
  //       </div>
  //     );
  //   };

  //   const formatfileName = (str, limit) => {
  //     let name = str?.split(".");
  //     if (name?.length > 1) {
  //       if (name[0].length > limit) {
  //         return name[0]?.substr(0, limit) + "... ." + name[name.length - 1]; // name upto limit character + extention
  //       } else {
  //         return name[0]?.substr(0, limit) + "." + name[name.length - 1];
  //       }
  //     } else {
  //       return name[0]?.substr(0, limit);
  //     }
  //   };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
  };

  const submitFeedback = () => {
    setAlertOpen(true);

    const client =
      props.userProfile?.user?.ismemberof?.[0]?.legalentity?.name || "";
    const user = `${props.userProfile?.user?.givenname || ""} ${
      props.userProfile?.user?.surname || ""
    }`.trim();
    
    props.postFeedBack({
      subject: type,
      body: description,
      client,
      user,
    });

    setType("");
    setDescription("");
    setTimeout(()=>{
        setAlertOpen(false);
    },4000)
  }

  return (
    <div className="_content" style={{ padding: "25px" }}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alertOpen}
        onClose={handleClose}
        TransitionComponent={Zoom}
      >
        <Alert severity={"success"} sx={{ width: "100%" }} className="bxShadow">
          <div className="primary">
            <b>{i18n.help.feedbackSentTitle}</b>
          </div>
          <div className="secondary">
            {i18n.help.feedbackSentText}
          </div>
        </Alert>
      </Snackbar>

      <div className="_header">
        <div className="_title">{i18n.help.feedbackTitle}</div>
      </div>

      <div style={{ width: "77%" }}>
        <FormControl fullWidth style={{ margin: "10px 0px 36px 0px" }}>
          <InputLabel id="demo-simple-select-label_helpandfeed">
            {i18n.help.feedbackTypeLabel}
          </InputLabel>
          <Select
            labelId="demo-simple-select-label_helpandfeed"
            id="demo-simple-select_helpandfeed"
            value={type}
            label={i18n.help.feedbackTypeLabel}
            onChange={(e) => {
              setType(e.target.value);
            }}
          >
            <MenuItem value={"Generelles Feedback"}>
              {i18n.help.feedbackTypeGeneral}
            </MenuItem>
            <MenuItem value={"Probleme beim Einrichten"}>
              {i18n.help.feedbackTypeSetup}
            </MenuItem>
            <MenuItem value={"Probleme beim Betrieb"}>
              {i18n.help.feedbackTypeOperation}
            </MenuItem>

            <MenuItem value={"Funktionalität und Features"}>
              {i18n.help.feedbackTypeFeatures}
            </MenuItem>
            <MenuItem value={"Sonstiges"}>{i18n.help.feedbackTypeOther}</MenuItem>
          </Select>

          <TextArea
            rows={4}
            placeholder={i18n.help.feedbackMessagePlaceholder}
            style={{ margin: "36px 0px" }}
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
            }}
          />

          {/* <div style={{ margin: "0px 0px 36px 0px" }}>
            <input
              id="myInputDoc"
              style={{ display: "none" }}
              type={"file"}
              accept={docs_enum}
              onChange={handleFileChange}
            />
            <Card
              sx={{
                height: 56,
                width: 328,
              }}
              variant="outlined"
              style={{ marginBottom: 5, borderColor: "#00000020" }}
            >
              <CardActionArea>
                {file ? (
                  renderFileDetails()
                ) : (
                  <label htmlFor="myInputDoc">
                    <CardHeader
                      sx={{
                        height: 56,
                        cursor: "pointer",
                      }}
                      className="NT_cardHeader"
                      avatar={
                        <Icon color="primary" className={""}>
                          <AttachmentAvatar />
                        </Icon>
                      }
                      title={"Anhänge hinzufügen"}
                    />
                  </label>
                )}
              </CardActionArea>
            </Card>
          </div> */}

          <Button
            variant="contained"
            disabled={type === "" || description === ""}
            sx={{ width: "194px" }}
            onClick={submitFeedback}
          >
            {i18n.help.sendFeedback}
          </Button>
        </FormControl>
      </div>
    </div>
  );
});
